<template>
  <div>
    <div class="title">修改账户信息（绑定手机、登录密码、支付密码、邮箱）？</div>
    <div class="content-info">
      <p class="txt1">
        <b>APP :</b> 进入“我的”界面，点击右上角”账户管理”按钮，点击“账户与安全”即可完成修改。
      </p>
      <ul class="p-left-6">
        <li>
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/3220d00d9118f9dbe44c1eddeb840f75.png"
            width="236"
          />
        </li>
        <li>
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/ac53a5e1ce296b9b9cd011b97b8bc321.png"
            width="236"
          />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/2bd2681ea08b45843245a0fa818b075f.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/563c0cdb45687c4fed6027555124e071.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/679e3c14f93a4ffcfc9c071ed548caf7.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
